import React from "react";

const QuickCraftRadioGroup = ({ label, options, name, selectedValue, onChange }) => {
  return (
    <p className={`craft-block__shortcut-select--${label.toLowerCase()}`}>
      <legend>{label}:</legend>
      {options.map((option) => {
        const id = `${name}_${option}`;
        return (
          <React.Fragment key={id}>
            <input
              type="radio"
              id={id}
              value={option}
              name={name}
              checked={selectedValue === option}
              onChange={onChange}
            />
            <label htmlFor={id} className={option}>{option}</label>
          </React.Fragment>
        );
      })}
    </p>
  );
};

export default QuickCraftRadioGroup;
